export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#1A1A2E] text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16">

        {/* Grid principal - 3 columnas con proporciones equilibradas */}
        <div className="grid grid-cols-1 md:grid-cols-[5fr_4fr_3fr] gap-12 lg:gap-16 items-start mb-14">

          {/* Columna 1 — Identidad */}
          <div className="flex flex-col">
            <img
              src="https://public.readdy.ai/ai/img_res/2228d458-d269-48e9-ac11-fe85c0bdb89a.png"
              alt="CMC Construcción y Carpintería"
              style={{ width: '160px', height: 'auto' }}
              className="mb-4"
            />
            <h3 className="text-lg font-bold leading-snug mb-3 text-white">
              CMC Construcción y Carpintería
            </h3>
            <p className="text-white/70 text-sm leading-7 max-w-sm">
              Empresa con base en Saltillo, Coahuila, con cobertura regional en Monterrey y su zona metropolitana. Más de 15 años de experiencia en construcción, carpintería e instalaciones.
            </p>
          </div>

          {/* Columna 2 — Contacto */}
          <div className="flex flex-col gap-7">

            {/* Ubicación */}
            <div>
              <h4 className="text-[11px] font-semibold tracking-widest uppercase text-[#C9A86A] mb-3">
                Ubicación
              </h4>
              <div className="flex items-start gap-2.5">
                <i className="ri-map-pin-2-line text-white/50 mt-0.5 flex-shrink-0 text-base"></i>
                <p className="text-sm text-white/85 leading-6">
                  Mayor Calletano Ramos #39<br />
                  Col. Francisco I. Madero, C.P. 25120<br />
                  Saltillo, Coahuila
                </p>
              </div>
            </div>

            {/* Teléfono */}
            <div>
              <h4 className="text-[11px] font-semibold tracking-widest uppercase text-[#C9A86A] mb-3">
                Teléfono
              </h4>
              <div className="flex items-center gap-2.5">
                <i className="ri-phone-line text-white/50 flex-shrink-0 text-base"></i>
                <a
                  href="tel:+528447098387"
                  className="text-sm text-white/85 hover:text-[#C9A86A] transition-colors whitespace-nowrap"
                >
                  (844) 709-8387
                </a>
              </div>
              <div className="flex items-center gap-2.5 mt-2">
                <i className="ri-whatsapp-line text-white/50 flex-shrink-0 text-base"></i>
                <a
                  href="https://wa.me/528447098387"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-white/85 hover:text-[#C9A86A] transition-colors whitespace-nowrap"
                >
                  WhatsApp Saltillo
                </a>
              </div>
              <div className="flex items-center gap-2.5 mt-2">
                <i className="ri-phone-line text-white/50 flex-shrink-0 text-base"></i>
                <a
                  href="tel:+528120789333"
                  className="text-sm text-white/85 hover:text-[#C9A86A] transition-colors whitespace-nowrap"
                >
                  (812) 078-9333 — Zona Monterrey
                </a>
              </div>
            </div>

          </div>

          {/* Columna 3 — Navegación */}
          <div className="flex flex-col">
            <h4 className="text-[11px] font-semibold tracking-widest uppercase text-[#C9A86A] mb-5">
              Navegación
            </h4>
            <ul className="flex flex-col gap-3">
              {[
                { id: 'inicio', label: 'Inicio' },
                { id: 'servicios', label: 'Servicios' },
                { id: 'proyectos', label: 'Proyectos' },
                { id: 'zonas', label: 'Zonas de Servicio' },
                { id: 'nosotros', label: 'Nosotros' },
                { id: 'contacto', label: 'Contacto' },
              ].map(({ id, label }) => (
                <li key={id}>
                  <button
                    onClick={() => scrollToSection(id)}
                    className="text-sm text-white/75 hover:text-[#C9A86A] transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

        </div>

        {/* Línea divisoria */}
        <div className="border-t border-white/10 pt-7">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-white/45 text-xs">
              © 2025 CMC Construcción y Carpintería. Todos los derechos reservados.
            </p>
            <div className="flex items-center gap-5 text-xs">
              <a
                href="#"
                className="text-white/45 hover:text-[#C9A86A] transition-colors whitespace-nowrap"
              >
                Aviso de Privacidad
              </a>
              <span className="text-white/20">|</span>
              <a
                href="#"
                className="text-white/45 hover:text-[#C9A86A] transition-colors whitespace-nowrap"
              >
                Términos y Condiciones
              </a>
              <span className="text-white/20">|</span>
              <a
                href="#"
                className="text-white/45 hover:text-[#C9A86A] transition-colors whitespace-nowrap"
              >
                Sitemap
              </a>
            </div>
          </div>
        </div>

      </div>
    </footer>
  );
}